import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, addDoc, updateDoc, deleteDoc, doc, query, onSnapshot } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();

export default function AdminAdsPage() {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  
  // حالة النموذج
  const [form, setForm] = useState({
    title: '',
    description: '',
    image_url: '',
    target_url: '',
    priority: 50,
    start_date: new Date().toISOString().split('T')[0],
    end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
  });

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const q = query(collection(db, 'ads'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
          const adsList = snapshot.docs
            .map(doc => ({ id: doc.id, ...doc.data() }))
            .sort((a, b) => (b.priority || 0) - (a.priority || 0));
          setAds(adsList);
          setLoading(false);
        });
        return () => unsubscribe();
      } catch (error) {
        console.error("Error fetching ads:", error);
        setLoading(false);
      }
    };

    fetchAds();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // تحويل التواريخ لـ ISO
      const startDateTime = new Date(form.start_date).toISOString();
      const endDateTime = new Date(form.end_date).toISOString();
      
      await addDoc(collection(db, 'ads'), {
        ...form,
        start_date: startDateTime,
        end_date: endDateTime,
        is_active: true,
        created_at: new Date().toISOString()
      });
      
      setMessage("✅ تم إضافة الإعلان بنجاح!");
      setForm({
        title: '',
        description: '',
        image_url: '',
        target_url: '',
        priority: 50,
        start_date: new Date().toISOString().split('T')[0],
        end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
      });
      
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Error adding ad:", error);
      setMessage("❌ فشل إضافة الإعلان.");
    } finally {
      setLoading(false);
    }
  };

  const toggleActive = async (adId, currentStatus) => {
    try {
      await updateDoc(doc(db, 'ads', adId), {
        is_active: !currentStatus
      });
    } catch (error) {
      console.error("Error toggling ad:", error);
    }
  };

  const handleDelete = async (adId) => {
    if (window.confirm('هل أنت متأكد من حذف هذا الإعلان؟')) {
      try {
        await deleteDoc(doc(db, 'ads', adId));
      } catch (error) {
        console.error("Error deleting ad:", error);
      }
    }
  };

  if (loading && !message) {
    return <div style={{ padding: '20px' }}>Loading ads...</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ color: '#1e40af', textAlign: 'center', marginBottom: '24px' }}>
        إدارة الإعلانات
      </h2>
      
      {message && (
        <div style={{ 
          padding: '12px', 
          borderRadius: '8px', 
          backgroundColor: message.includes('✅') ? '#f0fdf4' : '#fef2f2',
          color: message.includes('✅') ? '#166534' : '#b91c1c',
          marginBottom: '20px',
          border: message.includes('✅') ? '1px solid #bbf7d0' : '1px solid #fecaca'
        }}>
          {message}
        </div>
      )}

      {/* نموذج إضافة إعلان */}
      <div style={{ 
        backgroundColor: 'white', 
        padding: '24px', 
        borderRadius: '16px',
        border: '1px solid #e2e8f0',
        marginBottom: '24px'
      }}>
        <h3 style={{ color: '#1e40af', marginBottom: '16px' }}>
          إضافة إعلان جديد
        </h3>
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                العنوان *
              </label>
              <input
                type="text"
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
                required
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                رابط الصورة *
              </label>
              <input
                type="text"
                value={form.image_url}
                onChange={(e) => setForm({ ...form, image_url: e.target.value })}
                required
                placeholder="https://example.com/ad.jpg"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
          </div>
          
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
              الوصف *
            </label>
            <textarea
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              required
              rows="3"
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
              رابط التفاصيل *
            </label>
            <input
              type="url"
              value={form.target_url}
              onChange={(e) => setForm({ ...form, target_url: e.target.value })}
              required
              placeholder="https://example.com"
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px'
              }}
            />
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px', marginBottom: '24px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                الأولوية (1-100)
              </label>
              <input
                type="number"
                min="1"
                max="100"
                value={form.priority}
                onChange={(e) => setForm({ ...form, priority: parseInt(e.target.value) || 50 })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                تاريخ البدء
              </label>
              <input
                type="date"
                value={form.start_date}
                onChange={(e) => setForm({ ...form, start_date: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                تاريخ الانتهاء
              </label>
              <input
                type="date"
                value={form.end_date}
                onChange={(e) => setForm({ ...form, end_date: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
          </div>
          
          <button
            type="submit"
            disabled={loading}
            style={{
              backgroundColor: '#1e40af',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'جاري الإضافة...' : 'إضافة الإعلان'}
          </button>
        </form>
      </div>

      {/* عرض الإعلانات */}
      <div>
        <h3 style={{ color: '#1e40af', marginBottom: '16px' }}>
          الإعلانات الحالية ({ads.length})
        </h3>
        
        {ads.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', backgroundColor: 'white', borderRadius: '12px' }}>
            لا توجد إعلانات حالياً
          </div>
        ) : (
          <div style={{ display: 'grid', gap: '16px' }}>
            {ads.map(ad => (
              <div key={ad.id} style={{ 
                backgroundColor: 'white', 
                padding: '16px', 
                borderRadius: '12px',
                border: '1px solid #e2e8f0'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <h4 style={{ margin: '0 0 8px 0', color: '#0f172a' }}>{ad.title}</h4>
                    <p style={{ margin: 0, color: '#64748b', fontSize: '14px' }}>
                      {ad.description.substring(0, 100)}...
                    </p>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      onClick={() => toggleActive(ad.id, ad.is_active)}
                      style={{
                        backgroundColor: ad.is_active ? '#10b981' : '#f59e0b',
                        color: 'white',
                        border: 'none',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        fontSize: '12px'
                      }}
                    >
                      {ad.is_active ? 'مفعل' : 'معطل'}
                    </button>
                    <button
                      onClick={() => handleDelete(ad.id)}
                      style={{
                        backgroundColor: '#dc2626',
                        color: 'white',
                        border: 'none',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        fontSize: '12px'
                      }}
                    >
                      حذف
                    </button>
                  </div>
                </div>
                <div style={{ marginTop: '12px', fontSize: '12px', color: '#64748b' }}>
                  <span>الأولوية: {ad.priority}</span> | 
                  <span>من {new Date(ad.start_date).toLocaleDateString('ar-EG')} إلى {new Date(ad.end_date).toLocaleDateString('ar-EG')}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}